"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreuiSidebar = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const CoreuiSidebarDropdown_1 = require("./CoreuiSidebarDropdown");
const CoreuiSidebarItem_1 = require("./CoreuiSidebarItem");
const getSideBarItem = (context = '') => (item) => (react_1.default.createElement(CoreuiSidebarItem_1.CoreuiSidebarItem, { key: `${context}SidebarItem#${item.text}`, icon: item.icon, exact: item.exact, url: item.url, onClick: item.onClick }, item.text));
const getSidebarDropdown = (menu, clickHandler) => {
    const child = menu.children;
    return (react_1.default.createElement(CoreuiSidebarDropdown_1.CoreuiSidebarDropdown, { key: `Dropown#${menu.text}`, icon: menu.icon, text: menu.text, clickHandler: clickHandler, url: menu.url }, child.map(getSideBarItem('Dropdown#'))));
};
const getMenuTitle = (m) => (react_1.default.createElement("li", { key: `title#${m.text}`, className: "nav-title" }, m.text));
const generateMenuArray = (m) => {
    const clickHandler = (e) => {
        e.preventDefault();
        e.target.parentElement.classList.toggle('open');
    };
    if (m.type === 'title')
        return getMenuTitle(m);
    if (m.type === 'dropdown' && m.children) {
        return getSidebarDropdown(m, clickHandler);
    }
    return getSideBarItem()(m);
};
const CoreuiSidebarComponent = ({ menu }) => {
    const menuJsx = menu.map(generateMenuArray);
    return (react_1.default.createElement("div", { className: "sidebar pt-2" },
        react_1.default.createElement("div", { className: "sidebar-nav" },
            react_1.default.createElement("ul", { className: "nav" }, menuJsx))));
};
CoreuiSidebarComponent.propTypes = {
    menu: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        text: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]).isRequired,
    })).isRequired,
};
exports.CoreuiSidebar = CoreuiSidebarComponent;
//# sourceMappingURL=CoreuiSidebar.js.map